module.exports = __webpack_public_path__ + "img/71.70496aca.webp";